import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-checkbox-with-text',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './checkbox-with-text.component.html',
    styleUrl: './checkbox-with-text.component.css'
})
export class CheckboxWithTextComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  showError: boolean = false;
  constructor() {}
  ngOnInit() {}

  onCheckboxChange(): boolean {
    const control = this.formGroup.get(this.fields.fieldName);

    if (control?.value === true) {
      this.showError = false;
      control.markAsTouched(); // ✅ Checked → mark as touched
      return true;
    } else {
      this.showError = true;
      control?.markAsUntouched(); // ❌ Unchecked → mark as untouched
      return false;
    }

    control?.updateValueAndValidity(); // ✅ Recalculate validity
  }

  selectValue(event: any) {
    const checked = event.target.checked;
    const control = this.formGroup.get(this.fields.fieldName);

    if (control) {
      control.setValue(checked);
      control.updateValueAndValidity();
      this.showError = !checked && control.invalid;
    }
  }
  get formattedDisplayName(): string {
    return this.fields.displayName?.replace(/aggree/gi, 'agree') || '';
  }

  get termsUrl(): string {
    const apiEndpoint = environment.api_endpoint;
    if (!apiEndpoint) return '';

    const base = apiEndpoint.replace(/\/+$/, ''); // remove trailing /
    return `${base}/assets/docs/terms-of-use/index.html`;
  }
}
